import React from 'react';
import { useSelector } from 'react-redux';
import 'react-select-v1/dist/react-select.css';
import PerformedBy from '../performed-by/PerformedBy.js';
import HistItem from './HistItem.js';
const CaseCreationItem = (props) => {
    const lang = useSelector((s) => s.lang);
    if (!props.date)
        return null;
    return (React.createElement(HistItem, { date: props.date, timespan: props.timespan, heading: React.createElement("div", null,
            React.createElement("span", { style: { marginRight: '0.5em' } },
                React.createElement(PerformedBy, { performedBy: props.data.createdBy })),
            lang.history.caseCreated) }));
};
export default CaseCreationItem;
//# sourceMappingURL=CaseCreationItem.js.map